/**
 * Re-entrancy guard for DataTables Responsive 3.x `_resize()`.
 *
 * Responsive listens to `column-sizing` and calls `_resize()`, which calls
 * `columns.adjust()` whenever column visibility changed - and `columns.adjust()`
 * fires `column-sizing` again, synchronously. When hiding or showing a column
 * changes the width of the table container (e.g. the page's vertical scrollbar
 * appears/disappears), `_resize()` flips the same column on every pass and the
 * recursion never ends: "RangeError: Maximum call stack size exceeded" (TM-54).
 *
 * Still present upstream in Responsive 3.0.8 / 4.0.3 and DataTables 2.3.8.
 */

import DataTable from 'datatables.net';
import 'datatables.net-responsive';

const Responsive = DataTable.Responsive;
const originalResize = Responsive.prototype._resize;

// A nested call is skipped rather than deferred: the outer pass has already
// applied a valid layout, and a deferred retry would just flip it back again.
Responsive.prototype._resize = function (forceRedraw) {
    if (this._resizing) {
        return;
    }

    this._resizing = true;

    try {
        return originalResize.call(this, forceRedraw);
    } finally {
        this._resizing = false;
    }
};
